import { render, staticRenderFns } from "./DetalleView.vue?vue&type=template&id=44ba85a6&scoped=true"
import script from "./DetalleView.vue?vue&type=script&lang=js"
export * from "./DetalleView.vue?vue&type=script&lang=js"
import style0 from "./DetalleView.vue?vue&type=style&index=0&id=44ba85a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba85a6",
  null
  
)

export default component.exports